import { Navigate } from "react-router-dom";

// ─── Per-system route slices ──────────────────────────────────────────────────
import { authPublicRoutes } from "./Components/AuthRoutes";
import { coreRoutes } from "./Components/CoreRoutes";

import { globoProtectedRoutes, globoPublicRoutes } from "./Components/GloboRoutes";
import { othersPublicRoutes } from "./Components/OthersRoutes";

// ─── Assembled route tables ───────────────────────────────────────────────────
export var authProtectedRoutes = [
    ...coreRoutes,
    ...globoProtectedRoutes,

    // Catch-alls — must stay last
    { path: "/", exact: true, component: <Navigate to="/globo/dashboard" /> },
    { path: "*", component: <Navigate to="/pages-coming-soon" /> },
];

export var publicRoutes = [
    ...authPublicRoutes,
    ...othersPublicRoutes,
    ...globoPublicRoutes,
];